var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scanner",style:(_vm.cssVars)},[(_vm.bgEnabled)?_c('span',{staticClass:"background"}):_vm._e(),(_vm.borderEnabled)?_c('span',{staticClass:"border"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }